export default [
    {
        // [0]
        key: "code",
        label: "Personal",
        visible: true,
    },
    {
        // [10]
        key: "_01",
        label: "Ene",
        visible: true,
    },
    {
        // [10]
        key: "_02",
        label: "Feb",
        visible: true,
    },
    {
        // [10]
        key: "_03",
        label: "Mar",
        visible: true,
    },
    {
        // [10]
        key: "_04",
        label: "Abr",
        visible: true,
    },
    {
        // [10]
        key: "_05",
        label: "May",
        visible: true,
    },
    {
        // [10]
        key: "_06",
        label: "Jun",
        visible: true,
    },
    {
        // [10]
        key: "_07",
        label: "Jul",
        visible: true,
    },
    {
        // [10]
        key: "_08",
        label: "Ago",
        visible: true,
    },
    {
        // [10]
        key: "_09",
        label: "Set",
        visible: true,
    },
    {
        // [10]
        key: "_10",
        label: "Oct",
        visible: true,
    },
    {
        // [10]
        key: "_11",
        label: "Nov",
        visible: true,
    },
    {
        // [10]
        key: "_12",
        label: "Dic",
        visible: true,
    },
    {
        // [10]
        key: "totals",
        label: "Total",
        visible: true,
    },
]